import type {
  ImageWorkerRequest,
  ProcessImageRequest,
  TshirtGuide,
  WarmupImageWorkerRequest,
} from "../../../shared/image-processing";
import type { TshirtSide } from "../../../shared/tshirts";

export const createProcessImageRequest = (params: {
  readonly id: string;
  readonly file: File;
  readonly side: TshirtSide;
  readonly guide: TshirtGuide;
  readonly debugSegmentation: boolean;
}): ProcessImageRequest => ({
  id: params.id,
  type: "process-image",
  file: params.file,
  side: params.side,
  guide: params.guide,
  debugSegmentation: params.debugSegmentation,
});

export const isProcessImageRequest = (
  message: ImageWorkerRequest,
): message is ProcessImageRequest => message.type === "process-image";

export const createWarmupImageWorkerRequest = (params: {
  readonly id: string;
}): WarmupImageWorkerRequest => ({
  id: params.id,
  type: "warmup-image-worker",
});

export const isWarmupImageWorkerRequest = (
  message: ImageWorkerRequest,
): message is WarmupImageWorkerRequest =>
  message.type === "warmup-image-worker";
